import cx from 'classnames'

import { PropertyValue } from 'api/clients/PropertyClient'
import * as CSS from 'csstype'
import { fillColor } from 'common/PropertyForm/ColorInput'
import Styles from './PropertyValuePill.module.scss'
import { forwardRef } from 'react'
import { useObjectRef } from '@react-aria/utils'
import { ChevronDown } from 'almanac-ui/icons/12'
import { Pressable } from '@react-aria/interactions'
import { Icon } from 'almanac-ui/icons/Types'

interface Props {
  className?: string
  propertyValue: Pick<PropertyValue, 'value' | 'meta'>
  withCaret?: boolean
  frontIcon?: Icon
  size?: 'sm' | 'md'
}

export const PropertyValuePill = forwardRef<HTMLSpanElement, Props>(
  ({ propertyValue, className, withCaret, frontIcon: FrontIcon, size }, fRef) => {
    const ref = useObjectRef(fRef)
    const style: CSS.Properties = {
      ['--pill-bg-color' as any]: propertyValue.meta?.color,
      ['--pill-color' as any]: fillColor(propertyValue.meta?.color),
    }

    if (withCaret) {
      return (
        <Pressable ref={ref}>
          <span
            role="button"
            className={cx(Styles.pill, Styles.pressable, className, { [Styles.small]: size === 'sm' })}
            style={style}
          >
            {FrontIcon && <FrontIcon />}
            {propertyValue.value}
            {withCaret && <ChevronDown />}
          </span>
        </Pressable>
      )
    }

    return (
      <span className={cx(Styles.pill, className, { [Styles.small]: size === 'sm' })} style={style} ref={ref}>
        {propertyValue.value}
      </span>
    )
  },
)
